export default __webpack_public_path__ + "fonts/MaterialIcons-Regular.ttf";